import FormCreate from './create';
import FormList from './list';
import FormShow from './show';
import FormEdit from './edit';

export default {
    create: FormCreate,
    list: FormList,
    show: FormShow,
    edit: FormEdit
};